.jz{gap:0.125rem;}